const TypeTitleEnum= [
    {value:'terciario' ,label:'Terciario'},
    {value:'universitario' ,label:'Universitario'}
  ]

  export default TypeTitleEnum;